import React, { useState } from "react";
import Switcher from "./Components/Switcher/Switcher";
import { NewsCardData } from "./InsightsData";
import BlogCard from "./Components/BlogCard/BlogCard";

const options = [
  "All",
  "Compliance",
  "BCM",
  "Fraud",
  "GRC",
  "Outsourcing Risk",
];
const NewsPage = () => {
  const [activeOption, setActiveOption] = useState("All");
  const combinedData =
    activeOption === "All"
      ? [
          ...NewsCardData["All"],
          ...NewsCardData["Compliance"],
          ...NewsCardData["BCM"],
          ...NewsCardData["Fraud"],
          ...NewsCardData["GRC"],
          ...NewsCardData["Outsourcing Risk"],
        ]
      : //@ts-ignore
        NewsCardData[activeOption];
  return (
    <div>
      <Switcher
        options={options}
        current={activeOption}
        onChange={setActiveOption}
      />
      <div className="blogCardCnt">
        {/* @ts-ignore */}
        {combinedData?.map(({ heading, navTo, description }) => (
          <BlogCard heading={heading} navTo={navTo} description={description} />
        ))}
      </div>
    </div>
  );
};

export default NewsPage;
